"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaperStyles = exports.InputAdornmentStyles = exports.StyledTextField = void 0;
var styles_1 = require("@mui/material/styles");
var colors_1 = require("../ThemeProvider/colors");
var TextField_1 = __importDefault(require("../TextField"));
exports.StyledTextField = (0, styles_1.styled)(TextField_1.default)({
    '> div': {
        input: {
            paddingRight: '28px',
        },
    },
    svg: {
        transition: 'color .2s',
    },
    '&:hover, &:focus-within': {
        svg: {
            color: colors_1.tannerBlack,
        },
    },
});
exports.InputAdornmentStyles = {
    svg: {
        color: colors_1.tannerGray['600'],
    },
};
exports.PaperStyles = {
    marginTop: '4px',
    '& .MuiPickersCalendarHeader-root, .MuiIconButton-root .MuiSvgIcon-root': {
        color: colors_1.tannerGray['600'],
    },
    '& .MuiPickersCalendarHeader-label': {
        marginLeft: '6px',
        marginRight: '2px',
    },
    '& .MuiPickersArrowSwitcher-root': {
        fontSize: '1rem',
    },
    '& .MuiPickersCalendarHeader-labelContainer': {
        fontSize: '1rem',
        fontWeight: '700',
    },
    '& .MuiPickersCalendarHeader-root': {
        paddingLeft: '16px',
        paddingRight: '11px',
    },
    '& .MuiPickersDay-root, .MuiTypography-caption': {
        width: '40px',
        height: '40px',
    },
    '& .MuiDayPicker-slideTransition': {
        minHeight: '220px',
    },
    '& .MuiPickersToolbar-root': {
        padding: '24px 24px 0 24px',
        '& .MuiTypography-overline, .MuiIconButton-root': {
            display: 'none',
        },
        '& .MuiDatePickerToolbar-title': {
            padding: '0',
            margin: '0',
        },
        '& .MuiPickersToolbar-content': {
            margin: '0',
        },
    },
    '& .MuiDialogActions-root  button:first-of-type': {
        backgroundColor: colors_1.tannerGray[200],
        color: colors_1.tannerBlack,
    },
    '& .MuiCalendarOrClockPicker-root': {
        flexDirection: 'column',
    },
    '& .MuiDayPicker-weekDayLabel': {
        color: colors_1.tannerGray['600'],
    },
};
//# sourceMappingURL=styles.js.map